<template>
  <div>
    <asc-spinner-wrapper :loading="loading">
      <div
        v-for="(item, index) in getItems"
        :key="index"
        class="asc-alert-list"
        @click="handleItemClick(item)"
      >
        <asc-alert-item
          :key="item.title"
          class="asc-alert-list--margins"
          :status="item.status"
          :title="item.title"
          :value="item.value"
          color-icon-only
        ></asc-alert-item>
      </div>
    </asc-spinner-wrapper>
    <asc-no-data v-if="isEmpty"></asc-no-data>
  </div>
</template>

<script>
import { AscReportAlertMixin } from '@/components/mixins'
import AscAlertItem from './AscAlertItem'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscNoData from '@/components/atoms/AscNoData'

export default {
  name: 'AscAlertList',

  components: {
    AscAlertItem,
    AscSpinnerWrapper,
    AscNoData,
  },

  mixins: [AscReportAlertMixin],

  props: {
    values: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getItems() {
      return this.values.filter(item => item.alertEnabled)
    },
    isEmpty() {
      return (
        !this.loading &&
        this.values.filter(item => item.alertEnabled).length === 0
      )
    },
  },

  methods: {
    handleItemClick(item) {
      if (this.onReportAlertClick) {
        this.onReportAlertClick(item)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-alert-list {
  .asc-alert-list--margins {
    margin-top: $size-medium;
  }

  .asc-alert-item--container {
    .asc-alert-item {
      &:hover {
        cursor: pointer;
        background-color: $gray-0;
        text-decoration: underline !important;
      }
    }
  }
}
</style>
